import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BoxDiv } from './box';

import pauseButton from '../assets/icon/pause-sign.svg';
import playButton from '../assets/icon/play-button.svg';

const Wrapper = styled.div`
  margin: 30px 40px;
  border: 1px solid #ededed;
  borderRadius: 3px;
  
  @media print {
    display: none;
  }
`;

const PlayerContainer = styled(BoxDiv)`
  position: relative;
  width: 100% ;
  height: 113px;
  background-color: white;
  padding-left: 123px;
  padding-right: 40px;
`;

const ProgressTrack = styled.div`
  flex-shrink: 0;
  flex-grow: 1;
  height: 14px;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin: 0 10px;
`;

const Progress = styled(ProgressTrack)`
  min-width: 0;
  background-color: #f54746;
  margin: 0;
`;

const Title = styled.h2`
  font-weight: normal;
  color: black;
  font-size: 29px;
  line-height: 82px;
  margin: 0;
`;

const MusicName = styled.span`
  font-weight: 400;
  color: black;
  font-size: 29px;
  line-height: 82px;
  margin: 0;
  color: #22a7f0;
  padding-left: 0.3em;
`;

const Button = styled.img`
  height: 30px;
  position: absolute;
  left: 40px;
  top: 40px;
`;

const PlayTime = styled.span`
  color: #999;
  font-size: 24px;
  line-height: 1;
`;

const ProgressContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

class MusicPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      currentTime: 0,
      duration: 0,
    };
    this.updateProgress = this.updateProgress.bind(this);
    this.end = this.end.bind(this);
    this.handleDurationChange = this.handleDurationChange.bind(this);
  }

  componentDidMount() {
    const { audioContainer } = this;
    audioContainer.addEventListener('timeupdate', this.updateProgress);
    audioContainer.addEventListener('ended', this.end);
    audioContainer.addEventListener('durationchange', this.handleDurationChange);
    this.handlePlayProps();
  }

  componentDidUpdate({ prevPlay }) {
    if (prevPlay !== this.props.play) {
      this.handlePlayProps();
    }
  }

  componentWillUnmount() {
    const { audioContainer } = this;
    audioContainer.removeEventListener('timeupdate', this.updateProgress);
    audioContainer.removeEventListener('ended', this.end);
    audioContainer.removeEventListener('durationchange', this.handleDurationChange());
    this.audioContainer.pause();
    this.props.onPlayChange(false);
  }

  updateProgress() {
    const { duration, currentTime } = this.audioContainer;
    const progress = currentTime / duration;
    this.setState({
      progress,
      currentTime,
      duration,
    });
  }

  end() {
    this._playMusic();
  }

  handleAdjustProgress(e) {
    const { progressContainer } = this;
    const rect = progressContainer.getBoundingClientRect();
    let progress = (e.clientX - rect.left) / rect.width;
    progress = Math.min(1, progress);
    progress = Math.max(0, progress);
    this.audioContainer.currentTime = this.audioContainer.duration * progress;
    this.setState({
      progress,
      currentTime: this.audioContainer.currentTime,
      duration: this.audioContainer.duration,
    }, () => {
      this.audioContainer.play();
    });
  }

  handlePlayProps() {
    if (this.props.play) {
      this.audioContainer.play();
    } else {
      this.audioContainer.pause();
    }
  }

  handleDurationChange() {
    this.setState({
      duration: this.audioContainer.duration,
    });
  }

  _playMusic() {
    this.setState({
      progress: 0
    }, () => {
      this.audioContainer.currentTime = 0;
      this.audioContainer.play();
    });
  }

  padZeros(s) {
    return s >= 10 ? s : `0${s}`;
  }

  formatTime(sec) {
    return `${Math.floor(sec / 60)}:${this.padZeros(Math.floor(sec % 60))}`;
  }

  render() {
    const { source } = this.props;
    const activeMusic = source;
    const progressStyle = { width: `${this.state.progress * 100}%` };
    const { currentTime, duration } = this.state;

    return (
      <Wrapper>
        <PlayerContainer className='player-container' style={this.props.style}>
          <audio
            autoPlay={false}
            preload='auto'
            ref={(ref) => { this.audioContainer = ref; }}
            src={activeMusic.url} >
            <track kind='captions' />
          </audio>
          <div className='info-and-control'>
            <div className='music-info'>
              <Title>养生音乐: <MusicName>{activeMusic.title}</MusicName></Title>
            </div>
            <div className='control-container'>
              <div className='controls'>
                <Button
                  onClick={() => this.props.onPlayChange(!this.props.play)}
                  src={this.props.play ? pauseButton : playButton} />
              </div>
            </div>
          </div>

          <ProgressContainer>
            <PlayTime>{this.formatTime(currentTime)}</PlayTime>
            <ProgressTrack
              onClick={e => this.handleAdjustProgress(e)}
              innerRef={ref => this.progressContainer = ref} >
              <Progress style={progressStyle} />
            </ProgressTrack>
            <PlayTime>{this.formatTime(duration)}</PlayTime>
          </ProgressContainer>


        </PlayerContainer>
      </Wrapper>
    );
  }
}

MusicPlayer.propTypes = {
  play: PropTypes.bool,
  source: PropTypes.object.isRequired,
  style: PropTypes.object,
  onPlayChange: PropTypes.func.isRequired,
};

MusicPlayer.defaultProps = {
  play: false,
  style: {},
};

export default MusicPlayer;



// WEBPACK FOOTER //
// ./src/components/music-player.jsx